var app = app || {};
app.scroll = {
    init: function () {
        return app.scroll.dscroll(0), app.scroll.parallax(0), $(window).scroll(function () {
            var e;
            return e = $(window).scrollTop(), app.scroll.dscroll(e), app.scroll.parallax(e)
        }), $("[data-goto]").click(function (e) {
            var t;
            return t = $($(this).attr("data-goto")), app.scroll["goto"](t), e.preventDefault()
        })
    },
    dscroll: function (e) {
        var t, n;
        if (null == e && (e = !1), e || (e = $(window).scrollTop()), $(".dscroll").length) return n = 0, t = 0, $(".dscroll:visible").each(function () {
            var i, r, o;
            if (r = $(this), o = r.offset().top, e + $(window).height() > o && (r.addClass("dscroll--in"), o >= n - 25 && o <= n + 25 ? (t++, i = .2 * t, r.css({
                "-webkit-animation-delay": i + "s",
                "animation-delay": i + "s"
            })) : t = 0, n = o), e + $(window).height() <= o) return r.removeClass("dscroll--in")
        })
    },
    parallax: function (e) {
        if ($("[parallax]").length) return $("[parallax]").each(function () {
            var t, n, i, r, o;
            return i = $(this).attr("parallax").split(","), r = parseFloat(i[0]), o = parseFloat(i[1]), t = e * r, n = e * o, $(this).css({
                "-webkit-transform": "translate(" + t + "px," + n + "px)",
                "-ms-transform": "translate(" + t + "px," + n + "px)",
                transform: "translate(" + t + "px," + n + "px)"
            })
        })
    },
};

var openCollapsible = function (e, t) {
    return e.find(".faq__item").each(function () {
        return $(this).index() === t ? ($(this).find(".faq__answer").slideToggle(), $(this).toggleClass("faq__open")) : ($(this).find(".faq__answer").slideUp(), $(this).removeClass("faq__open"))
    })
};


var openTabs = function (e, t) {
    if (
        e.find(".tabs__header .tab").removeClass("tab--active"),
            e.find(".tabs__header .tab").eq(t).addClass("tab--active"),
            e.find(".tabs__body .tab").removeClass("tab--active"),
            e.find(".tabs__body .tab").eq(t).addClass("tab--active"),
            app.scroll)
        return app.scroll.dscroll()
};


$("#derco-template-css .faq").each(function () {
    var e;
    return e = $(this), e.find(".faq__item:not(.faq__open) .faq__answer").hide(), e.find(".faq__question").click(function () {
        var t;
        return t = $(this).parent().index(), openCollapsible(e, t)
    })
});

$("#derco-template-css .tabs").each(function () {
    var e;
    return e = $(this), e.find(".tab--active").length || openTabs(e, 0), e.find(".tabs__header .tab").click(function (t) {
        var n;
        return t.preventDefault(), n = $(this).index(), openTabs(e, n)
    })
});
